export interface Movie {
  id: number;
  title: string;
  enTitle: string;
  year: number;
  rating: number;
  genres: string[];
  region: string;
  director: string;
  cast: string[];
  duration: number;
  poster: string;
  backdrop: string;
  synopsis: string;
  type: 'movie';
  popularity: number;
  releaseDate: string;
  featured?: boolean;
}

export const movies: Movie[] = [
  {
    id: 1001,
    title: '星际远征',
    enTitle: 'Interstellar Expedition',
    year: 2024,
    rating: 9.1,
    genres: ['科幻', '冒险'],
    region: '大陆',
    director: '林远山',
    cast: ['陈牧野', '苏晚棠', '周景深', '许星河'],
    duration: 148,
    poster: 'https://readdy.ai/api/search-image?query=A%20lone%20astronaut%20silhouetted%20before%20a%20glowing%20spiral%20wormhole%2C%20epic%20sci-fi%20film%20key%20art%2C%20deep%20navy%20space%20background%20with%20warm%20orange%20accent%20glow%2C%20dramatic%20rim%20lighting%2C%20ultra%20detailed%2C%20professional%20cinematic%20poster%20composition&width=400&height=600&seq=movie-poster-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Deep%20space%20nebula%20with%20a%20giant%20spiral%20wormhole%20glowing%20orange%20and%20amber%2C%20lone%20spaceship%20silhouette%2C%20cinematic%20wide%20shot%2C%20dark%20navy%20tones%2C%20dramatic%20atmospheric%20lighting%2C%20high%20detail%20sci-fi%20key%20art&width=1600&height=900&seq=hero-backdrop-01&orientation=landscape',
    synopsis: '一支由科学家与宇航员组成的远征队，穿越人类史上第一道稳定虫洞，去寻找可能拯救地球的第二家园。当星际航行的孤独与团队的信任被一次次撕裂，他们必须回答同一个问题：探索的尽头究竟是希望，还是新的深渊。',
    type: 'movie',
    popularity: 9860,
    releaseDate: '2024-07-12',
    featured: true,
  },
  {
    id: 1002,
    title: '暗夜追凶',
    enTitle: 'Hunt in the Dark',
    year: 2023,
    rating: 8.6,
    genres: ['悬疑', '犯罪'],
    region: '香港',
    director: '关启铭',
    cast: ['程一鸣', '黎婉清', '何家豪'],
    duration: 126,
    poster: 'https://readdy.ai/api/search-image?query=A%20detective%20walking%20through%20a%20rain-soaked%20neon%20alley%20at%20night%2C%20moody%20crime%20thriller%20film%20poster%2C%20deep%20navy%20shadows%20with%20orange%20streetlight%20accent%2C%20dramatic%20contrast%20lighting%2C%20ultra%20detailed%20professional%20cinematic%20key%20art&width=400&height=600&seq=movie-poster-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Rain-soaked%20city%20street%20at%20night%20with%20reflective%20wet%20asphalt%20and%20war%20orange%20streetlamps%2C%20film%20noir%20atmosphere%2C%20deep%20blue%20shadows%2C%20cinematic%20wide%20shot%2C%20high%20detail%20crime%20thriller%20key%20art&width=1600&height=900&seq=hero-backdrop-02&orientation=landscape',
    synopsis: '一宗尘封十五年的连环悬案，因为一枚指纹重新浮出水面。退休在即的老刑警与执着较真的年轻法医，在城市的夜色中抽丝剥茧，却发现真相离他们比想象中更近，也更危险。',
    type: 'movie',
    popularity: 8230,
    releaseDate: '2023-11-03',
  },
  {
    id: 1003,
    title: '山河故人梦',
    enTitle: 'Dreams of the Old Land',
    year: 2022,
    rating: 8.9,
    genres: ['剧情', '历史'],
    region: '大陆',
    director: '沈砚秋',
    cast: ['秦望川', '叶知秋', '陆知远'],
    duration: 134,
    poster: 'https://readdy.ai/api/search-image?query=A%20weathered%20scholar%20gazing%20across%20misty%20mountains%20at%20dawn%2C%20epic%20period%20drama%20film%20poster%2C%20deep%20navy%20mountain%20silhouettes%20with%20warm%20amber%20sunrise%20accent%2C%20refined%20cinematic%20lighting%2C%20ultra%20detailed%20painterly%20composition&width=400&height=600&seq=movie-poster-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Layered%20misty%20mountain%20ranges%20at%20golden%20dawn%20with%20a%20lone%20ancient%20temple%2C%20epic%20historical%20drama%20wide%20shot%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20atmospheric%20cinematic%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-backdrop-03&orientation=landscape',
    synopsis: '跨越半个世纪的家族记忆，从战火中的离别到和平年代的重逢。一封迟到了四十年的家书，牵出三代人的抉择与守望，也见证了一片土地与它儿女们的沧桑巨变。',
    type: 'movie',
    popularity: 7520,
    releaseDate: '2022-09-30',
    featured: true,
  },
  {
    id: 1004,
    title: '城市之光',
    enTitle: 'Light of the City',
    year: 2024,
    rating: 8.2,
    genres: ['剧情', '爱情'],
    region: '大陆',
    director: '温言',
    cast: ['顾屿', '白露', '林清和'],
    duration: 118,
    poster: 'https://readdy.ai/api/search-image?query=A%20young%20couple%20standing%20on%20a%20rooftop%20overlooking%20a%20glittering%20city%20at%20dusk%2C%20romantic%20drama%20film%20poster%2C%20deep%20navy%20sky%20with%20warm%20orange%20city%20lights%2C%20soft%20cinematic%20lighting%2C%20ultra%20detailed%20professional%20key%20art&width=400&height=600&seq=movie-poster-04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20sprawling%20city%20skyline%20at%20dusk%20with%20warm%20orange%20window%20lights%20and%20deep%20navy%20sky%2C%20romantic%20urban%20wide%20shot%2C%20soft%20glow%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=hero-backdrop-04&orientation=landscape',
    synopsis: '深夜便利店的店员与加班到凌晨的建筑师，因为一杯温热的关东煮相遇。两个在城市里各自孤独的人，用一整年的时间学会了一件事：光不必照亮全世界，只要能照亮彼此就够了。',
    type: 'movie',
    popularity: 6890,
    releaseDate: '2024-02-14',
  },
  {
    id: 1005,
    title: '深海救援',
    enTitle: 'Deep Sea Rescue',
    year: 2023,
    rating: 8.4,
    genres: ['动作', '灾难'],
    region: '美国',
    director: 'Marcus Cole',
    cast: ['张野', '伊莎贝尔·格兰特', '雷·诺顿'],
    duration: 132,
    poster: 'https://readdy.ai/api/search-image?query=A%20diver%20illuminated%20by%20an%20orange%20flare%20deep%20underwater%20beside%20a%20metal%20submarine%2C%20action%20disaster%20film%20poster%2C%20deep%20navy%20ocean%20with%20warm%20emergency%20glow%2C%20dramatic%20underwater%20lighting%2C%20ultra%20detailed%20cinematic%20key%20art&width=400&height=600&seq=movie-poster-05&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Deep%20dark%20ocean%20trench%20with%20a%20large%20submarine%20silhouette%20and%20glowing%20orange%20emergency%20lights%2C%20tense%20underwater%20wide%20shot%2C%20deep%20navy%20tones%2C%20cinematic%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-backdrop-05&orientation=landscape',
    synopsis: '一艘深海科考潜艇在万米海沟失联，舱内氧气只剩下二十小时。一支临时组建的救援小队必须在极限环境中与时间赛跑，而下潜越深，他们要面对的不仅是水压，还有人性最深处的恐惧。',
    type: 'movie',
    popularity: 8110,
    releaseDate: '2023-06-23',
  },
  {
    id: 1006,
    title: '笑闹一家亲',
    enTitle: 'Family Shenanigans',
    year: 2024,
    rating: 7.8,
    genres: ['喜剧', '家庭'],
    region: '大陆',
    director: '郝乐天',
    cast: ['刘大壮', '王宝娟', '郝开心'],
    duration: 105,
    poster: 'https://readdy.ai/api/search-image?query=A%20cheerful%20extended%20family%20posing%20together%20in%20a%20warm%20living%20room%2C%20feel-good%20comedy%20film%20poster%2C%20deep%20navy%20accents%20with%20bright%20orange%20pops%2C%20warm%20bright%20lighting%2C%20ultra%20detailed%20playful%20key%20art&width=400&height=600&seq=movie-poster-06&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20cozy%20festive%20home%20interior%20full%20of%20warm%20orange%20string%20lights%20and%20deep%20navy%20evening%20light%2C%20joyful%20family%20comedy%20wide%20shot%2C%20cheerful%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=hero-backdrop-06&orientation=landscape',
    synopsis: '爷爷的八十大寿把散落各地的一家人重新凑到一起，一场关于拆迁款的家庭会议意外变成鸡飞狗跳的闹剧。吵吵闹闹过后，他们才发现，让一家人坐在一起吃饭，本身就是最珍贵的礼物。',
    type: 'movie',
    popularity: 5980,
    releaseDate: '2024-01-26',
  },
  {
    id: 1007,
    title: '江湖刀客',
    enTitle: 'Blade of the Rivers',
    year: 2021,
    rating: 8.5,
    genres: ['武侠', '动作'],
    region: '大陆',
    director: '徐长空',
    cast: ['萧北风', '柳如烟', '铁无双'],
    duration: 121,
    poster: 'https://readdy.ai/api/search-image?query=A%20lone%20swordsman%20standing%20on%20a%20misty%20cliff%20at%20dusk%2C%20wuxia%20martial%20arts%20film%20poster%2C%20deep%20navy%20mist%20with%20warm%20amber%20sunset%20accent%2C%20dramatic%20movement%20lighting%2C%20ultra%20detailed%20cinematic%20key%20art&width=400&height=600&seq=movie-poster-07&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Misty%20river%20valley%20at%20dusk%20with%20a%20swordsman%20silhouette%20on%20a%20cliff%2C%20wuxia%20epic%20wide%20shot%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20atmospheric%20cinematic%20key%20art%2C%20high%20detail&width=1600&height=900&seq=hero-backdrop-07&orientation=landscape',
    synopsis: '十年前的一场恩怨，让江湖第一名刀客封刀归隐。当昔日的仇家带着一纸血书找上门，他不得不再度拔刀，去直面那个他一直在逃避的真相，也直面那个早已不是当年模样的自己。',
    type: 'movie',
    popularity: 7010,
    releaseDate: '2021-10-15',
  },
  {
    id: 1008,
    title: '时间旅人',
    enTitle: 'The Time Traveler',
    year: 2023,
    rating: 8.7,
    genres: ['科幻', '爱情'],
    region: '韩国',
    director: '金相赫',
    cast: ['李在勋', '韩素敏', '朴志勋'],
    duration: 129,
    poster: 'https://readdy.ai/api/search-image?query=A%20figure%20walking%20through%20shattering%20glass%20of%20time%20with%20glowing%20orange%20clock%20fragments%2C%20sci-fi%20romance%20film%20poster%2C%20deep%20navy%20void%20background%2C%20ethereal%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=movie-poster-08&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=An%20abstract%20swirling%20tunnel%20of%20glowing%20orange%20clock%20fragments%20and%20deep%20navy%20light%2C%20sci-fi%20time%20travel%20wide%20shot%2C%20ethereal%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=hero-backdrop-08&orientation=landscape',
    synopsis: '他拥有跳跃时间的能力，却始终追不回那个在他记忆里永远微笑的女孩。当他一次次回到相遇的那天，才发现每一次改变都会让未来偏离得更远。有些爱，不是用来挽回的，而是用来记住的。',
    type: 'movie',
    popularity: 8740,
    releaseDate: '2023-08-18',
    featured: true,
  },
  {
    id: 1009,
    title: '荒野孤旅',
    enTitle: 'The Lonely Wild',
    year: 2022,
    rating: 8.1,
    genres: ['冒险', '剧情'],
    region: '英国',
    director: 'Oliver Grant',
    cast: ['亨利·布莱克', '艾米莉·肖'],
    duration: 115,
    poster: 'https://readdy.ai/api/search-image?query=A%20weathered%20traveler%20crossing%20vast%20sand%20dunes%20at%20sunset%20alone%2C%20survival%20adventure%20film%20poster%2C%20deep%20navy%20shadows%20with%20warm%20amber%20desert%20glow%2C%20epic%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=movie-poster-09&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Endless%20desert%20dunes%20under%20a%20deep%20navy%20twilight%20sky%20with%20a%20trail%20of%20footprints%2C%20survival%20adventure%20wide%20shot%2C%20epic%20lonely%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=hero-backdrop-09&orientation=landscape',
    synopsis: '一架失事的小型飞机把一个人留在了无边的荒野。没有信号，没有水，只有一台破旧的相机。在求生的三十天里，他用镜头记录下自己，也重新认识了那个他以为早已了解的内心。',
    type: 'movie',
    popularity: 6320,
    releaseDate: '2022-05-20',
  },
  {
    id: 1010,
    title: '迷雾山庄',
    enTitle: 'Misty Manor',
    year: 2024,
    rating: 7.9,
    genres: ['悬疑', '惊悚'],
    region: '英国',
    director: 'Oliver Grant',
    cast: ['伊芙琳·凯奇', '托马斯·里德', '露西·法尔'],
    duration: 112,
    poster: 'https://readdy.ai/api/search-image?query=A%20grand%20isolated%20manor%20wreathed%20in%20thick%20mist%20with%20one%20warm%20orange%20lit%20window%2C%20gothic%20mystery%20thriller%20film%20poster%2C%20deep%20navy%20fog%20and%20moonlight%2C%20eerie%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=movie-poster-10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20gothic%20manor%20silhouette%20on%20a%20hill%20shrouded%20in%20deep%20navy%20mist%20with%20a%20single%20orange%20window%20glow%2C%20eerie%20mystery%20wide%20shot%2C%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=hero-backdrop-10&orientation=landscape',
    synopsis: '六个陌生人收到同一封邀请函，来到一座藏在迷雾深处的山庄。当第一场雪落下，退路被封死，他们才发现主人早已不在。每个人带来的秘密，正一个接一个地要了他们的命。',
    type: 'movie',
    popularity: 7240,
    releaseDate: '2024-10-04',
  },
  {
    id: 1011,
    title: '青春不散场',
    enTitle: 'Youth Never Ends',
    year: 2022,
    rating: 7.6,
    genres: ['青春', '校园'],
    region: '大陆',
    director: '苏念',
    cast: ['夏小满', '程野', '林一诺'],
    duration: 108,
    poster: 'https://readdy.ai/api/search-image?query=High%20school%20students%20laughing%20on%20a%20sports%20field%20at%20golden%20hour%2C%20youth%20coming-of-age%20film%20poster%2C%20warm%20orange%20sunlight%20with%20deep%20navy%20shadows%2C%20nostalgic%20cinematic%20lighting%2C%20ultra%20detailed%20cheerful%20key%20art&width=400&height=600&seq=movie-poster-11&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20school%20running%20track%20at%20golden%20sunset%20with%20warm%20orange%20light%20and%20deep%20navy%20shadows%2C%20nostalgic%20youth%20wide%20shot%2C%20cinematic%20warm%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=hero-backdrop-11&orientation=landscape',
    synopsis: '高三最后一学期，五个性格迥异的少年因为一场话剧走到一起。他们约定十年后再聚，却在毕业那天各奔东西。多年以后，当他们重新翻开那本泛黄的同学录，青春仿佛从未散场。',
    type: 'movie',
    popularity: 5480,
    releaseDate: '2022-07-08',
  },
  {
    id: 1012,
    title: '极速飞驰',
    enTitle: 'Full Throttle',
    year: 2023,
    rating: 8.0,
    genres: ['动作', '赛车'],
    region: '美国',
    director: 'Marcus Cole',
    cast: ['戴维·里德', '佐伊·陈', '卡尔·门罗'],
    duration: 124,
    poster: 'https://readdy.ai/api/search-image?query=A%20racing%20car%20drifting%20on%20a%20wet%20night%20circuit%20with%20orange%20light%20trails%2C%20high-octane%20action%20racing%20film%20poster%2C%20deep%20navy%20night%20background%2C%20dynamic%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=movie-poster-12&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20night%20race%20circuit%20with%20streaking%20orange%20light%20trails%20and%20deep%20navy%20asphalt%2C%20high-speed%20action%20wide%20shot%2C%20dynamic%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=hero-backdrop-12&orientation=landscape',
    synopsis: '退役车手为了兑现对亡兄的承诺，重回地下赛道。面对曾经背叛他的搭档与飞速进化的新世代车手，他必须用方向盘证明：真正的速度，来自不肯认输的心。',
    type: 'movie',
    popularity: 7660,
    releaseDate: '2023-05-12',
  },
  {
    id: 1013,
    title: '寻梦东京',
    enTitle: 'Dreaming in Tokyo',
    year: 2024,
    rating: 8.3,
    genres: ['剧情', '爱情'],
    region: '日本',
    director: '佐藤绫',
    cast: ['高桥凉介', '新垣美咲', '中村悠'],
    duration: 119,
    poster: 'https://readdy.ai/api/search-image?query=A%20young%20woman%20crossing%20a%20rainy%20Tokyo%20street%20under%20orange%20lanterns%2C%20gentle%20romantic%20drama%20film%20poster%2C%20deep%20navy%20evening%20tones%2C%20soft%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=movie-poster-13&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20rainy%20Tokyo%20street%20at%20night%20with%20warm%20orange%20lanterns%20and%20deep%20navy%20wet%20pavement%2C%20gentle%20romantic%20wide%20shot%2C%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=hero-backdrop-13&orientation=landscape',
    synopsis: '一个为了厨艺梦想只身来到东京的女孩，在一家深夜小馆里遇到了同样迷茫的料理长。两个异乡人用一道道家常菜温暖彼此，也在陌生的城市里，找到了属于自己的位置。',
    type: 'movie',
    popularity: 6940,
    releaseDate: '2024-03-22',
  },
  {
    id: 1014,
    title: '旧日回响',
    enTitle: 'Echoes of Yesterday',
    year: 2021,
    rating: 8.8,
    genres: ['剧情', '历史'],
    region: '大陆',
    director: '沈砚秋',
    cast: ['叶知秋', '周正阳', '许青桐'],
    duration: 137,
    poster: 'https://readdy.ai/api/search-image?query=An%20old%20radio%20on%20a%20wooden%20table%20in%20a%20dim%20room%20with%20warm%20orange%20light%2C%20nostalgic%20period%20drama%20film%20poster%2C%20deep%20navy%20shadows%2C%20intimate%20cinematic%20lighting%2C%20ultra%20detailed%20key%20art&width=400&height=600&seq=movie-poster-14&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=A%20dim%20old%20room%20with%20warm%20orange%20lamp%20glow%20and%20deep%20navy%20shadows%2C%20nostalgic%20period%20drama%20wide%20shot%2C%20intimate%20cinematic%20atmosphere%2C%20high%20detail%20key%20art&width=1600&height=900&seq=hero-backdrop-14&orientation=landscape',
    synopsis: '一台老旧的收音机，串联起一座工厂、一代工人和一段被时代洪流冲刷的记忆。当工人子弟重新打开它，那些沉寂多年的声音再次响起，讲述着关于尊严、坚守与热爱的旧日故事。',
    type: 'movie',
    popularity: 6480,
    releaseDate: '2021-12-10',
  },
];